import React, { useState } from 'react';
import Styled from 'styled-components';
import { fontQuicksand } from './mixin';
import { device } from '../../utils/responsive_utilities';

const PurchaseCta = ({clickHandler, titleDuration, fromCreditForm, settings, disableBtn, showDiscountChanges, selectedPlan}) => {
  let ctaText = settings.trialAvailable ? (showDiscountChanges && selectedPlan?.display_name==="Yearly" ? 'Claim Offer' : fromCreditForm ? 'Start your free trial' : 'Continue') : 'Pay now' ;
  let ctaSubText = settings.trialAvailable ? (showDiscountChanges && selectedPlan?.display_name==="Yearly" ? 'with 7-day free trial' : fromCreditForm ? '' : `with ${settings.trailDays || 7}-days free trial`) : '';
  
  return (
    <CtaContainer inCreditForm={fromCreditForm}>
      <BtnWrapper disableBtn={disableBtn}>
        <PurchaseBtn onClick={(event)=>clickHandler(event, titleDuration)} inCreditForm={fromCreditForm} disableBtn={disableBtn}>
          <p>{ctaText}</p>
          <StyledSpan>{ctaSubText}</StyledSpan>
        </PurchaseBtn>
      </BtnWrapper>
    </CtaContainer>
    
  )
}
export default PurchaseCta;

export const CtaContainer = Styled.div`
  background-color: #14195361;
  margin:auto;
  position: ${props=>props.inCreditForm? "fixed" : 'static'};
  bottom: 0;
  width: 47.2rem;
  height: 14.0rem;
  padding: 1rem 0 0 0;
  @media ${device.PhoneLargeScreen} {
    position: ${props=>props.inCreditForm? "fixed" : 'static'};
    bottom: 0;
    width: 37rem;
    height: 6rem;
  }
  @media ${device.Phone} {
    position: ${props=>props.inCreditForm? "fixed" : 'static'};
    bottom: 0;
    width: 34rem;
    height: 5.2rem;
  }
`
export const BtnWrapper = Styled.div`
  cursor: ${(props) => (props.disableBtn ? 'not-allowed' : '')};
`;

export const PurchaseBtn = Styled.a`
  pointer-events: ${props=>props.disableBtn? 'none':''};
  width: 100%;
  height: 6.4rem;
  background-color: #fff;
  ${fontQuicksand(2, 2.6, 7)};
  margin: ${props=>props.inCreditForm? 0 : '3rem auto 1rem'};
  border-radius: 3.3rem;
  color: #141953;
  border: 0;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
    height: 4.8rem;
    ${fontQuicksand(1.6, 2, 7)};
    margin: ${props=>props.inCreditForm? 0 : '4.8rem auto 1rem'};
  }

  @media ${device.Phone} {
    width: 34rem;
    height: 4.8rem;
    ${fontQuicksand(1.6, 2, 7)};
    margin: ${props=>props.inCreditForm? 0 : '4.8rem auto 1rem'};
  }
`;
export const StyledSpan = Styled.span`
  ${fontQuicksand(1.3, 1.9, 5)};
`; 